import { RootState } from 'editor/src/store/index';

const isMediaElementSelectedByUuid = (state: RootState, uuid: number) =>
  state.editor.selectedElementUuids.indexOf(uuid) !== -1;

export default isMediaElementSelectedByUuid;
